import React from 'react';
import { motion } from 'framer-motion';

export default function ProgressBar({ current, total }) {
  const percentage = Math.round(((current + 1) / total) * 100);

  return (
    <div className="w-full px-4">
      <div className="flex justify-between text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">
        <span>Step {current + 1} of {total}</span>
        <span>{percentage}% Complete</span>
      </div>
      <div className="h-3 w-full bg-slate-100 rounded-full overflow-hidden border border-slate-50">
        <motion.div
          className="h-full bg-gradient-to-r from-[#7C3AED] to-[#14B8A6] rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        />
      </div>
    </div>
  );
}